<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <div class="containerBg">
      <Nav curNavId="8" pathUrl='suyuan' @circle="clickNav" />
      <div class="down_down">
        <!-- 左 -->
        <div class="left_txts">
          <div class="left_txts_top">
            <div class="g_g_bt animate__animated animate__fadeInDown">
              <img src="../assets/img/nysy/lx.png" class="titIcon" />
              溯源查询
            </div>
            <div class="l_t_t_d1">
              <div class="l_t_t_d1_l animate__animated animate__fadeInLeft"><leftBar1 /></div>
              <div class="l_t_t_d1_r animate__animated animate__fadeInRight">
                <div class="l_t_t_d1_r_left">
                  <h6><countTo :startVal="0" :endVal="2562" :duration="1000" class="fontNum"></countTo>人</h6>
                  <img src="../assets/img/nysy/lj.png" />
                  <span>累计查询人数</span>
                </div>
                <div class="l_t_t_d1_r_right">
                  <h6><countTo :startVal="0" :endVal="6852" :duration="1000" class="fontNum"></countTo>次</h6>
                  <img src="../assets/img/nysy/lj.png" />
                  <span>累计查询次数</span>
                </div>
              </div>
            </div>
            <div class="l_t_t_d2  animate__animated animate__zoomIn">
              <leftBar2 />
            </div>
          </div>
          <div class="left_txts_down  animate__animated animate__fadeInUp">
            <div class="g_g_bt">
              <img src="../assets/img/nysy/lx.png" class="titIcon" />
              溯源扫码
<!--              溯源类型-->
            </div>
            <div class="left_txts_down_d">
<!--              <LeftPie />-->
              <div class="down_d_sym" v-for="(item, index) in plant" :key="index">
                <img :src="item.img" alt="" />
                <h5>{{ item.name }}</h5>
              </div>
            </div>
          </div>
        </div>
        <!-- 中 -->
        <div class="middle_txts">
          <div class="m_txt_dh">
            <div
                class="m_txt_dh_d_bg  animate__animated animate__fadeInDown"
                v-for="(item, index) in dhdata"
                :key="index"
            >
              <h5>
                <countTo :startVal="0" :endVal="item.number" :duration="1000" class="fontNum"></countTo><span>{{ item.unit }}</span>
              </h5>
              <h6>{{ item.name }}</h6>
            </div>
          </div>
          <div class="sy_map">
            <!--            <centerRadar />-->
            <!--            <div class="sy_map_bg">-->
            <!--              <div class="centerItem" v-for="(item,index) in centerList" :key="index">-->
            <!--                <span>{{item.name}}</span>-->
            <!--                <span>{{item.value}}{{item.unit}}</span>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <!--          <div><img src="../assets/img/nysy/zs.png" /> </div>-->
        </div>
        <!-- 右 -->
        <div class="right_txts">
          <div class="right_txts_top">
            <div class="g_g_bt">
              <img src="../assets/img/nysy/lx.png" class="titIcon" />
              生长环境评估
            </div>
            <div class="right_txts_top_l"></div>
            <div class="right_txts_top_m">正常</div>
            <div class="right_txts_top_r"></div>
            <div class="top_qw">
              <h4 class="qw_sz">28℃</h4>
              <h5 class="qw_name">气温</h5>
            </div>
            <div class="top_sz">
              <h4 class="qw_sz">80%</h4>
              <h5 class="qw_name">水质</h5>
            </div>
            <div class="top_list">
              <div
                  class="top_list_d"
                  v-for="(item, index) in hjdata"
                  :key="index"
              >
                <div class="sx_bg"></div>
                <h4>{{ item.number }}{{ item.unit }}</h4>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="right_txts_middle">
            <div class="g_g_bt">
              <img src="../assets/img/nysy/lx.png" class="titIcon" />
              销售数据
            </div>
            <div class="txts_middle_dh">
              <div
                  class="txts_middle_dh_list"
                  :class="{ xzzt: xsindex == index }"
                  v-for="(item, index) in xsdata"
                  :key="index"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="z_x_t"><rightLine /></div>
          </div>
          <div class="right_txts_down">
            <div class="g_g_bt">
              <img src="../assets/img/nysy/lx.png" class="titIcon" />
              农残抽检分析
            </div>
            <div class="gd_list">
              <dv-scroll-board
                  :config="config"
                  style="width: 100%; height: 100%"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="db_bg"></div>
    </div>
  </div>
  <div class="footer">本产品由来村网提供技术支持</div>
  <CircleNav :isShow="circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import leftBar2 from "../components/suyuan/leftBar2.vue";
import leftBar1 from "../components/suyuan/leftBar1.vue";
import rightLine from "@/components/suyuan/rightLine.vue";
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import LeftPie from "@/components/suyuan/leftPie.vue"
import centerRadar from "../components/suyuan/centerRadar3";
import Nav from "../components/nav.vue";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";
import CircleNav from "@/components/circleNav.vue";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();

    const state = reactive({
      config: {
        header: [
          '<span style="color:#fff;">抽检时间</span>',
          '<span style="color:#fff;">品种</span>',
          '<span style="color:#fff;">批次</span>',
          '<span style="color:#fff;">基数</span>',
          '<span style="color:#fff;">合格率</span>',
        ],

        data: [
          ["2023.10.05", "小麦", "20230301BATCH001", "26", "100%"],
          ["2023.12.20", "玉米", "20230301BATCH001", "18", "100%"],
          ["2024.01.10", "大豆", "20230301BATCH001", "26", "100%"],
          ["2024.02.20", "花生", "20230301BATCH001", "18", "100%"],
          ["2024.03.08", "小麦", "20230301BATCH001", "56", "100%"],
          ["2024.03.25", "花生", "20230301BATCH001", "23", "100%"],
          ["2024.04.09", "大豆", "20230301BATCH001", "18", "100%"],
          ["2024.04.20", "小麦", "20230301BATCH001", "45", "100%"],
        ],
        headerBGC: "#04585E",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [120],
        align: ["center"],
        // rowNum:6
      },
      plant: [
        {
          name: "溯源1",
          img: require("@/assets/img/nysy/code/1.png"),
        },
        {
          name: "溯源2",
          img: require("@/assets/img/nysy/code/2.png"),
        },
        {
          name: "溯源3",
          img: require("@/assets/img/nysy/code/3.png"),
        },
        {
          name: "溯源4",
          img: require("@/assets/img/nysy/code/4.png"),
        },
        {
          name: "溯源5",
          img: require("@/assets/img/nysy/code/5.png"),
        },
        {
          name: "溯源6",
          img: require("@/assets/img/nysy/code/6.png"),
        },
      ],

      dhdata: [
        {
          name: "农事记录",
          number: 958,
          unit: "条",
        },
        {
          name: "农作物追溯",
          number: 22569,
          unit: "吨",
        },
        {
          name: "农资记录",
          number: 256,
          unit: "条",
        },
        {
          name: "可追溯地块",
          number: 68,
          unit: "",
        },
        {
          name: "农产品销售省份",
          number: 13,
          unit: "",
        },
      ],
      hjdata: [
        {
          name: "虫害",
          number: 56,
          unit: "%",
        },
        {
          name: "病害",
          number: 42,
          unit: "%",
        },
        {
          name: "土壤状态",
          number: 86,
          unit: "%",
        },
        {
          name: "土壤成分",
          number: 74,
          unit: "%",
        },
      ],
      xsdata: [
        {
          name: "玉米",
        },
        {
          name: "小麦",
        },
        {
          name: "大豆",
        },
        {
          name: "花生",
        },
      ],
      startVal: 0,
      xsindex: 0,
      circleShow:false,
      centerList:[
        {name:"温度",value:22.2,unit:"℃"},
        {name:"湿度",value:22.2,unit:"%"},
        {name:"光照",value:22.2,unit:"lux"},
        {name:"风速",value:22.2,unit:"m/s"},
        {name:"雨量",value:22.2,unit:"mm"}
      ]
    });

    // 在 onMounted 中初始化地图
    onMounted(() => {
      getData()
    });

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
    function getData(){
      axios
          .get("https://zhfarm.laicunwang.com/api/environment/shangcaizzxxqx", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
          .then((res) => {
            // console.log(res);
            state.centerList[0].value = res.data.kqdata.kqwd
            state.centerList[1].value = res.data.kqdata.kqsd
            state.centerList[2].value = res.data.kqdata.gz
            state.centerList[3].value = res.data.kqdata.kqfs
            state.centerList[4].value = res.data.kqdata.yl

            console.log(state.centerdata)
          });
    }
    onUnmounted(() => {});
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),

      clickReturn,
      clickNav,
      circleHiddlen
    };
  },
  components: {
    CircleNav,
    leftBar2,
    leftBar1,
    countTo,
    rightLine,
    centerRadar,
    Nav,
    LeftPie
  },
};
</script>
<style lang="less" scoped>
.footer{
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 10000;
  font-weight: bold;
}
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/nysy/bjjjj.jpg") no-repeat;
  .containerBg {
    position: absolute;
    width: 100%;
    height: 100%;
    //background: url("../assets/img/nysy/bj/bj.png") no-repeat;
    //background-size: 100% 100%;
    z-index: 999;
    .db_bg {
      width: 100%;
      height: 29px;
      background: url("../assets/img/nysy/bj/x.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      bottom: 0;
    }
  }
  .g_g_bt {
    width: 100%;
    height: 40px;
    background: url("../assets/img/nysy/btk.png") no-repeat top center;
    background-size: 100% 100%;
    font-size: 15px;
    color: #fff;
    line-height: 40px;
    text-align: left;
    text-indent: 3em;
    position: relative;
    .titIcon {
      position: absolute;
      top: 9px;
      left: 20px;
      width: 20px;
      height: 20px;
      animation: titIcon 5s linear infinite;
      // animation-delay: 5s;
    }
  }
  .down_down {
    width: 100%;
    height: 88%;
    position: absolute;
    top: 12%;
    // border: #fff 1px solid;
    display: flex;
    flex-flow: row;

    .left_txts {
      width: 463px;
      height: 100%;
      margin: 0 10px;
      // border: #fff 1px solid;
      display: flex;
      flex-direction: column;
      .left_txts_top {
        width: 100%;
        height: 540px;
        // border: #fff 1px solid;
        .l_t_t_d1 {
          width: 100%;
          height: 190px;
          padding: 10px 0 0;
          box-sizing: border-box;
          // border: #fff 1px solid;
          display: flex;
          .l_t_t_d1_l {
            flex: 1;
            height: 100%;
            // border: #fff 1px solid;
            animation-delay: .4s;
          }
          .l_t_t_d1_r {
            flex: 1;
            height: 100%;
            // border: #fff 1px solid;
            position: relative;
            animation-delay: .2s;

            .l_t_t_d1_r_left {
              width: 100px;
              height: 130px;
              position: absolute;
              color: #fff;
              left: 3%;
              top: 19%;
              display: flex;
              flex-direction: column;
              h6 {
                width: 100%;
                font-size: 14px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                font-weight: normal;
                .fontNum{
                  font-size: 18px;
                }
              }
              img {
                width: 100px;
                height: 90px;
                animation: left1Img 2s linear infinite;
              }
              span {
                width: 100%;
                font-size: 13px;
                height: 20px;
                line-height: 20px;
              }
            }
            .l_t_t_d1_r_right {
              width: 100px;
              height: 130px;
              position: absolute;
              color: #fff;
              right: 3%;
              top: 19%;
              display: flex;
              flex-direction: column;
              h6 {
                width: 100%;
                font-size: 14px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                font-weight: normal;
                .fontNum{
                  font-size: 18px;
                }
              }
              img {
                width: 100px;
                height: 90px;
                animation: left1Img 2s linear infinite;
              }
              span {
                width: 100%;
                font-size: 13px;
                height: 20px;
                line-height: 20px;
              }
            }
          }
        }
        .l_t_t_d2 {
          width: 100%;
          height: 300px;
          // border: #fff 1px solid;
          animation-delay: .6s;
        }
      }

      .left_txts_down {
        width: 100%;
        flex: 1;
        // border: #fff 1px solid;
        //background-color: #041820;
        animation-delay: .8s;
        .left_txts_down_d {
          width: 100%;
          height: 80%;
          // border: #fff 1px solid;
          margin-top: 2%;
          display: flex;
          flex-flow: row;
          flex-wrap: wrap;
          position: relative;
          .down_d_sym {
            width: 33.33333333333333%;
            height: 50%;
            // margin-top: 1%;
            position: relative;
            // border: #fff 1px solid;

            img {
              width: 90px;
              height: 80px;
              position: absolute;
              bottom: 30px;
              left: 21.5%;
            }
            h5 {
              width: 100%;
              height: 20px;
              font-size: 14px;
              color: #fff;
              bottom: 5px;
              text-align: center;
              position: absolute;
            }
          }
        }
      }
    }
    .middle_txts {
      flex: 1;
      height: 100%;
      margin: 0 10px;
      .m_txt_dh {
        width: 100%;
        height: 68px;
        display: flex;
        position: relative;
        z-index: 1;
        .m_txt_dh_d_bg {
          width: 125px;
          height: 68px;
          margin: 0 3%;
          background: url("../assets/img/nysy/ns.png") no-repeat top center;
          background-size: 100% 100%;
          h5 {
            width: 100%;
            height: 40px;
            line-height: 40px;
            color: #37ddad;
            text-align: center;
            font-weight: normal;
            margin-top: 5px;
            .fontNum{font-size: 30px;}
            span {
              font-size: 16px;
            }
          }
          h6 {
            font-size: 13px;
            color: #fff;
            text-align: center;
          }
        }
        .m_txt_dh_d_bg:nth-child(1){
          animation-delay: .1s;
        }
        .m_txt_dh_d_bg:nth-child(2){
          animation-delay: .2s;
        }
        .m_txt_dh_d_bg:nth-child(3){
          animation-delay: .3s;
        }
        .m_txt_dh_d_bg:nth-child(4){
          animation-delay: .4s;
        }
        .m_txt_dh_d_bg:nth-child(5){
          animation-delay: .5s;
        }
      }

    }
    .sy_map {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .sy_map_bg{
        width:900px ;
        height: 900px;
        background: url("../assets/img/nysy/SY2.gif") no-repeat top center;
        background-size: 100% 100%;
        position: relative;
        z-index: 0;
        .centerItem{
          position: absolute;
          top:0;
          left:0;
          width: 69px;
          height: 45px;
          //border: 1px solid #f00;
          span{
            display: block;
            color: #000;
            //text-align: left;
            line-height:14px;
            font-weight: bold;
            font-size: 12px;


          }
        }
        .centerItem:nth-child(1){
          top: 322px;
          left: 26px;
          //animation: fontSize 0.8s linear infinite;
        }

      }
    }
  }

  .left_txt {
    width: 500px;
    height: 88%;
    position: absolute;
    top: 9%;
    left: 3%;
    display: flex;
    flex-direction: column;
    z-index: 999;
  }

  .right_txts {
    width: 463px;
    height: 100%;
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    .right_txts_top {
      width: 100%;
      height: 240px;
      position: relative;

      .right_txts_top_l {
        width: 73px;
        height: 95px;
        background: url("../assets/img/nysy/zby.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 100px;
        top: 57px;
        animation-duration: 2s;
        animation-name: moveRightLeft;
        animation-timing-function: linear; /* 可以根据需要调整动画速度曲线 */
        animation-iteration-count: infinite; /* 添加这一行让动画无限循环 */
      }
      .right_txts_top_m {
        width: 114px;
        height: 105px;
        background: url("../assets/img/nysy/zxy.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 175px;
        top: 57px;
        z-index: 9999;
        line-height: 105px;
        color: #fff;
        font-size: 20px;
        // animation: guangying 2s linear infinite;
      }
      .right_txts_top_r {
        width: 73px;
        height: 95px;
        background: url("../assets/img/nysy/yby.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        right: 104px;
        top: 57px;
        animation-duration: 2s;
        animation-name: moveRightLeft;
        animation-timing-function: linear; /* 可以根据需要调整动画速度曲线 */
        animation-iteration-count: infinite; /* 添加这一行让动画无限循环 */
      }

      .top_qw {
        width: 100px;
        height: 50px;
        // border: #fff 1px solid;
        position: absolute;
        left: 40px;
        top: 77px;
      }
      .top_sz {
        width: 100px;
        height: 50px;
        // border: #fff 1px solid;
        position: absolute;
        right: 40px;
        top: 77px;
      }
      .qw_sz {
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        color: #37ddad;
      }
      .qw_name {
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        color: #fff;
      }
      .top_list {
        width: 90%;
        height: 60px;
        border: #39d6c4 2px solid;
        position: absolute;
        bottom: 10px;
        left: 5%;
        display: flex;
        .top_list_d {
          height: 100%;
          flex: 1;
          // border: #fff 1px solid;
          position: relative;
          h4 {
            width: 100%;
            height: 25px;
            line-height: 34px;
            font-size: 16px;
            color: #37ddad;
          }
          span {
            display: block;
            width: 100%;
            height: 25px;
            line-height: 25px;
            font-size: 13px;
            color: #fff;
          }
          .sx_bg {
            width: 1px;
            height: 30px;
            background: url("../assets/img/nysy/dx.png") no-repeat top center;
            background-size: 100% 100%;
            position: absolute;
            right: 0;
            top: 15px;
          }
        }
        .top_list_d:last-child {
          .sx_bg {
            display: none;
          }
        }
      }
    }
    .right_txts_middle {
      width: 100%;
      height: 320px;
      .txts_middle_dh {
        width: 100%;
        height: 40px;
        display: flex;
        margin-top: 15px;
        .txts_middle_dh_list {
          flex: 1;
          height: 100%;
          margin: 0 10px;
          border: #39d6c4 1px solid;
          font-size: 14px;
          color: #fff;
          line-height: 40px;
          text-align: center;
          //cursor: pointer;
        }
        //.txts_middle_dh_list:hover,
        //.xzzt {
        //  color: #2eb667;
        //  cursor: pointer;
        //}
      }
      .z_x_t {
        width: 100%;
        height: 210px;
      }
    }
    .right_txts_down {
      flex: 1;
      width: 100%;
      .gd_list {
        width: 100%;
        height: 79%;
        margin-top: 2%;
      }
    }
  }
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes fontSize {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
